import { Link } from "react-router-dom";
import type { Title } from "@/mocks/titles";

interface TitleCardProps {
  item: Title;
  variant?: "default" | "compact";
}

export default function TitleCard({ item, variant = "default" }: TitleCardProps) {
  const isCompact = variant === "compact";

  return (
    <Link
      to={`/detail/${item.id}`}
      data-product-shop
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className={`relative w-full overflow-hidden bg-primary-950 ${isCompact ? "aspect-[3/4]" : "aspect-[3/4]"}`}>
        <img
          src={item.cover}
          alt={`${item.title} 影视封面`}
          title={`${item.title} 海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-primary-950/85 via-primary-950/30 to-transparent"></div>
        {item.badge && (
          <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
            {item.badge}
          </span>
        )}
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-primary-950/70 px-1.5 py-0.5 text-[11px] font-medium text-secondary-400">
          <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-2 bottom-2 flex items-center justify-between text-[11px] text-background-200">
          <span className="rounded-md bg-background-50/15 px-1.5 py-0.5 backdrop-blur">
            {item.type === "movie" ? "电影" : "电视剧"}
          </span>
          <span>{item.year}</span>
        </div>
      </div>
      <div className={isCompact ? "p-2.5" : "p-3 md:p-3.5"}>
        <h3 className={`truncate font-medium text-foreground-950 transition-colors group-hover:text-primary-700 ${isCompact ? "text-sm" : "text-sm md:text-base"}`}>
          {item.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">{item.englishTitle}</p>
        <div className="mt-2 flex flex-wrap gap-1">
          {item.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900"
            >
              {genre}
            </span>
          ))}
          <span className="rounded-md bg-background-100 px-1.5 py-0.5 text-[11px] text-foreground-600">
            {item.region}
          </span>
        </div>
      </div>
    </Link>
  );
}